export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="section-container relative z-10 w-full py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              实时更新 · 爆料不停
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              51吃瓜官网
              <span className="block text-primary-500 mt-1">最新娱乐黑料爆料第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mb-3 font-medium">
              真实爆料，速度吃瓜，全网最快最全
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51吃瓜官网专注娱乐八卦与黑料爆料，覆盖明星恋情、综艺翻车、豪门秘闻、影视内幕等多领域热点。
              作为51吃瓜爆料网与51吃瓜黑料网的核心入口，我们7x24小时全天候追踪娱乐圈最新动态，
              每条51吃瓜今日黑料均经多方交叉核实，确保51吃瓜爆料真实可信。无论是最新黑料、娱乐八卦爆料还是黑料曝光，
              51吃瓜网吃瓜爆料第一站让你吃瓜快人一步。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">日均爆料数</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">百万</div>
                <div className="text-xs text-foreground-500 mt-1">吃瓜群众在线</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-eye-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-300 text-primary-600 rounded-full font-semibold text-base hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-300/20 via-accent-300/20 to-primary-200/20 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20with%20warm%20crimson%20and%20gold%20lighting%2C%20abstract%20entertainment%20news%20theme%2C%20microphone%20silhouette%20against%20spotlight%20glow%2C%20dark%20moody%20atmosphere%20with%20warm%20accents%2C%20magazine%20cover%20aesthetic%2C%20professional%20cinematic%20look%2C%20luxurious%20texture%20background%2C%20high%20contrast%20dramatic%20composition%2C%20elegant%20mysterious%20vibe&width=800&height=700&seq=hero-51cg-main&orientation=portrait"
                alt="51吃瓜官网 - 最新娱乐黑料爆料第一站"
                className="relative w-full h-auto rounded-2xl object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.minHeight = '300px';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}